import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
    id: string
    title?: string
    message: string
    type: ToastType
    duration?: number
}

const toasts = ref<Toast[]>([])

export const useToast = () => {
    const add = (toast: Omit<Toast, 'id'>) => {
        const id = Math.random().toString(36).substring(2, 9)
        const newToast: Toast = {
            id,
            ...toast,
            duration: toast.duration ?? 5000
        }

        toasts.value.push(newToast)

        if (newToast.duration !== 0) {
            setTimeout(() => {
                remove(id)
            }, newToast.duration)
        }

        return id
    }

    const remove = (id: string) => {
        const index = toasts.value.findIndex(t => t.id === id)
        if (index > -1) {
            toasts.value.splice(index, 1)
        }
    }

    const success = (message: string, title?: string, duration?: number) => {
        return add({ message, title, type: 'success', duration })
    }

    const error = (message: string, title?: string, duration?: number) => {
        return add({ message, title, type: 'error', duration })
    }

    const warning = (message: string, title?: string, duration?: number) => {
        return add({ message, title, type: 'warning', duration })
    }

    const info = (message: string, title?: string, duration?: number) => {
        return add({ message, title, type: 'info', duration })
    }

    return {
        toasts,
        add,
        remove,
        success,
        error,
        warning,
        info
    }
}
